angular.module('wbDashboard').controller('LoginOTPControllerAurea',
    ['$scope', 'Auth', 'Login', 'Message', '$timeout', 'bugsnagClient',
function ($scope, Auth, Login, Message, $timeout, bugsnagClient) {

    $scope.pageData.sending = false;
    $scope.pageData.success = false;
    $scope.pageData.firstOTPRequest = true;
    $scope.pageData.otpSending = {};
    $scope.pageData.autoSubmit = true;
    $scope.data = {code:""};

    if (bugsnagClient.user) {
        bugsnagClient.user.id = Auth.getClientId();
    }

    var timeoutSec = 30;

    $scope.$watch('data.code', function(code) {
        if (code) {
            var digits = code.replace(/[^0-9]/g, "").slice(0, 6);
            if (digits.length === 6 && $scope.pageData.autoSubmit) {
                $scope.pageData.autoSubmit = false;
                $scope.validateOTP();
            }
        }

    });

    $scope.getOTP = function(type) {
        if (!Auth.isLoggedIn()) {
            $scope.$state.go("public.login");
            $scope.pageData.sending = false;
            return;
        }

        if ($scope.pageData.sending) return;

        $scope.data.code = "";

        $scope.pageData.otpSending[type] = true;
        $scope.pageData.sending = true;

        Login.getOTP(type).then(function() {
            if (!$scope.pageData.firstOTPRequest) {
                Message.set({
                    type: "success",
                    text: `Code has been sent via ${type}, you should receive it shortly.`
                });
            }

            countDown(type);

            $scope.pageData.firstOTPRequest = false;
        }).catch(function(response) {
            let message;

            message = `There was an issue sending the code via ${type}.`;
            if (response && response.data && typeof response.data.error === "string") {
                message = response.data.error;
            } else if (response && response.data && response.data.error && response.data.error.message) {
                message = response.data.error.message;
            }
            Message.set({
                type: "warning",
                text: message
            });
            $scope.pageData.otpSending[type] = false;
        }).finally(function() {
            $scope.pageData.sending = false;
        });

    };
    $timeout(function() {
        $scope.getOTP('sms');
    }, 100);

    function countDown(type) {
        if ($scope.pageData.otpSending[type] === true) {
            $scope.pageData.otpSending[type] = timeoutSec;
        }
        if ($scope.pageData.otpSending[type] <= 1) {
            $scope.pageData.otpSending[type] = false;
        }
        if (typeof $scope.pageData.otpSending[type] === "number") {
            $scope.pageData.otpSending[type]--;
            $timeout(() => { countDown(type); }, 1000);
        }
    }

    $scope.validateOTP = function() {

        $scope.pageData.sending = true;
        Login.validateOTP($scope.data.code).then(function() {
            $scope.validLogin();
        }).catch(function(response) {
            let message = "Could not validate code, please try again.";
            if (response.data && response.data.message) {
                message = response.data.message;
            }
            Message.set({
                type: "warning",
                text: message
            });
        }).finally(function() {
            $scope.pageData.sending = false;
        });
    };

}]);
